<template>
    <div
        :class="[
            'activePage',
            { activePageBlue: tabIndex == 0 },
            { activePageRed: tabIndex == 1 },
        ]"
    >
        <div class="header">
            <div class="topTitle">
                <span>- 两种比</span><span>赛模式 -</span>
            </div>
            <div
                :class="[
                    'switchTab',
                    { tabBtnBlue: tabIndex == 0 },
                    { tabBtnRed: tabIndex == 1 },
                ]"
            >
                <div @click="tabIndex = 0"></div>
                <div @click="tabIndex = 1"></div>
            </div>
            <div v-if="tabIndex == 0">
                <div class="productDesc">
                    <div class="title">
                        <span></span>最佳驾驶车王赛<span></span>
                    </div>
                    <div class="desc">
                        针对预缴开通优驾保的用户，以驾驶行为作为参赛依据，评选出“最佳驾驶车王”。
                    </div>
                    <div class="points mb20"><span>活动奖励</span></div>
                    <div class="list">
                        周榜单：第1名300元，第2名200元，第3名100元
                    </div>
                    <div class="list">
                        月榜单：第1名500元，第2名300元，第3名200元
                    </div>
                    <div class="list mb30">
                        年榜单：第1名1000元，第2名800元，第3名500元
                    </div>
                    <div class="points mb20"><span>奖励方式</span></div>
                    <div class="list">客服联系您领取（榜单公布次日）</div>
                </div>
                <div class="productDesc">
                    <div class="title">
                        <span></span>优秀驾驶员权益<span></span>
                    </div>
                    <div class="desc">
                        根据每趟运货行程，给予当次货运司机安全驾驶红包。
                    </div>
                    <div class="points mb20"><span>奖励方式</span></div>
                    <div class="list">
                        每趟货运结束后短信通知权益金额及领取方式（权益金每周发放）
                    </div>
                </div>
                <div class="productDesc">
                    <div class="title"><span></span>活动说明<span></span></div>
                    <div class="points mb20"><span>活动时间</span></div>
                    <div class="desc">2022年7月1日至2022年12月31日</div>
                    <div class="points mb20"><span>榜单公布</span></div>
                    <div class="list">周榜单：次周2</div>
                    <div class="list">月榜单：次月第二个工作日</div>
                    <div class="list">年榜单：2023年1月5日</div>
                    <div class="points mb20"><span>活动声明</span></div>
                    <div class="list">
                        以上活动解释权归天津华盛保险经纪有限公司。
                    </div>
                </div>
            </div>
            <!-- ↑ 蓝 ↑    ↓ 红 ↓ -->
            <div v-if="tabIndex == 1" class="descRed">
                <div class="productDesc">
                    <div class="title">
                        <span></span>最佳分享车王赛<span></span>
                    </div>
                    <div class="desc">
                        针对优驾保车王，分享并邀请车友参与此活动，
                        车友预缴开户您可参与评选“最佳分享车王”。
                    </div>
                    <div class="points mb20"><span>活动奖励</span></div>
                    <div class="list">
                        周榜单：第1名300元，第2名200元，第3名100元
                    </div>
                    <div class="list">
                        月榜单：第1名500元，第2名300元，第3名200元
                    </div>
                    <div class="list mb30">
                        年榜单：第1名1000元，第2名800元，第3名500元
                    </div>
                    <div class="points mb20"><span>奖励方式</span></div>
                    <div class="list">客服联系您领取（榜单公布次日）</div>
                </div>
                <div class="productDesc">
                    <div class="title">
                        <span></span>优秀分享者权益<span></span>
                    </div>
                    <div class="desc">
                        根据分享记录，针对邀请车友预缴开通优驾保账
                        户，可获得分享权益，邀请1人获20元权益金。
                    </div>
                    <div class="points mb20"><span>奖励方式</span></div>
                    <div class="list">红包（每周发放）</div>
                </div>
                <div class="productDesc">
                    <div class="title"><span></span>活动说明<span></span></div>
                    <div class="points mb20"><span>活动时间</span></div>
                    <div class="desc">2022年6月28日至2022年12月31日</div>
                    <div class="points mb20"><span>榜单公布</span></div>
                    <div class="list">周榜单：次周2</div>
                    <div class="list">月榜单：次月第二个工作日</div>
                    <div class="list">年榜单：2023年1月5日</div>
                    <div class="points mb20"><span>活动声明</span></div>
                    <div class="list">
                        以上活动解释权归天津华盛保险经纪有限公司。
                    </div>
                </div>
            </div>
        </div>

        <div class="bottomBtn blueStyleBtn" v-if="tabIndex == 0">
            <div @click="checkList">查看榜单</div>
            <div @click.stop="jump">马上参与</div>
        </div>

        <div class="bottomBtn redStyleBtn" v-if="tabIndex == 1">
            <div @click="checkList">查看榜单</div>
            <div class="share" @click.stop="shareBtn">立即分享</div>
        </div>

        <div class="myBehavior" @click="isShowMyBehavior = true" v-if="tabIndex == 0">
        <!-- <div class="myBehavior" @click="isShowMyBehavior = true"> -->
            <img src="../../assets/active/score.png" alt="" />
            <span>我的评分</span>
        </div>
        <div class="mask-div" v-show="isShowMyBehavior"></div>
        <div class="myBehaviorBox" v-show="isShowMyBehavior">
            <div class="behavior-title">我的评分</div>
            <div class="behavior-content">
                <img
                    class="close"
                    src="../../assets/active/close.png"
                    alt=""
                    @click="isShowMyBehavior = false"
                    v-if="isLogin && myBehaviorData.startAddrInfo"
                />
                <div v-if="!isLogin || !myBehaviorData.startAddrInfo" class="tipsBox">
                    <img src="../../assets/active/tips-img.png" />
                    <div class="tipText mb18 lSpacing4" v-if="!isLogin">
                        您还未投保优驾保，无法参与比赛 预缴开户后可参与
                    </div>
                    <div class="tipText mb18 lSpacing4" v-else>
                        您还未使用优驾保，无法参与比赛 预缴开户且录入货运行程后可参与
                    </div>
                </div>
                <div v-if="isLogin && myBehaviorData.startAddrInfo">
                    <div class="beatNums">
                        优驾保驾驶行为评分超过<span>{{ beatNums }}</span
                        >人
                    </div>
                    <div class="behaviorList">
                        <span class="key">出发地:</span
                        ><span class="val">{{ myBehaviorData.startAddrInfo }}</span>
                    </div>
                    <div class="behaviorList">
                        <span class="key">目的地:</span
                        ><span class="val">{{ myBehaviorData.endAddrInfo }}</span>
                    </div>
                    <div class="behaviorList">
                        <span class="key">行驶里程:</span
                        ><span class="val"
                            >{{ tbSubpolicyTrackInfo.mileage }}公里</span
                        >
                    </div>
                    <div class="behaviorList">
                        <span class="key">行驶时长:</span
                        ><span class="val">{{
                            timeChange(tbSubpolicyTrackInfo.esDrivingTime)
                        }}</span>
                    </div>
                    <div class="behaviorList">
                        <span class="key">预缴保费:</span
                        ><span class="val">{{ myBehaviorData.premium }}元</span>
                    </div>
                    <div class="behaviorList">
                        <span class="key">实缴保费:</span
                        ><span class="val">{{ myBehaviorData.payMoney }}元</span
                        ><span class="save"
                            >省{{ myBehaviorData.saveMoney }}元</span
                        >
                    </div>
                    <div class="title">本次驾驶行为</div>
                    <div class="stateList">
                        <div>
                            <span class="circle">1</span>
                            <span class="style">百公里超速次数（次）</span>
                        </div>
                        <span class="result">{{
                            myBehaviorData.overspeedNumberDesc
                        }}</span>
                    </div>
                    <div class="stateList">
                        <div>
                            <span class="circle">2</span>
                            <span class="style">疲劳驾驶时长（分钟）</span>
                        </div>
                        <span class="result">{{
                            myBehaviorData.fatigueDrivingDesc
                        }}</span>
                    </div>
                    <div class="stateList">
                        <div>
                            <span class="circle">3</span>
                            <span class="style">平稳驾驶时长占比</span>
                        </div>
                        <span class="result">{{
                            myBehaviorData.smoothDrivingRatioDesc
                        }}</span>
                    </div>
                </div>
                <div class="improveBox">
                    <div class="title">如何提升驾驶行为，节省保费？</div>
                    <div class="list">
                        <div class="topTitle">
                            <span class="circle">1</span
                            ><span>通过减少百公里超速次数（次）;</span>
                        </div>
                        <div class="topTitle">
                            <span class="circle">2</span
                            ><span>通过降低疲劳驾驶时长（分钟）;</span>
                        </div>
                        <div class="topTitle">
                            <span class="circle">3</span
                            ><span>通过提升平稳驾驶 时长占比。</span>
                        </div>
                    </div>
                </div>
                <img
                    class="close-bottom"
                    src="../../assets/active/bottom-close.png"
                    alt=""
                    @click="isShowMyBehavior = false"
                    v-if="!isLogin || !myBehaviorData.startAddrInfo"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {
    getSessionObj,
    getUrlParams,
    getUserInfo,
    isAndroid,
    setSessionObj,
    showMsg,
} from "../../common/utils";
// import { myTrack } from "../../common/zhuge";

const isUserOrderUrl =
    "/hsbxjj-excellent-driving-insurance/championship/isUserOrder";
const getMyBehaviorUrl =
    "/hsbxjj-excellent-driving-insurance/championship/getMyBehavior";
const getRankingDataUrl =
    "/hsbxjj-excellent-driving-insurance/championship/getRankingData";

export default {
    name: "activePage",
    data() {
        return {
            tabIndex: 0,
            mobile: "",
            userId: "",
            isOut: navigator.userAgent.indexOf("daka") > -1,
            beatNums: "",
            isLogin: false,
            isShowMyBehavior: false,
            myBehaviorData: {},
            tbSubpolicyTrackInfo: {},
            jumpUrl: "",
        };
    },
    watch:{
        tabIndex(){
            // myTrack(`车旺争霸赛-活动页-点击${this.tabIndex ? '分享车王' : '驾驶车王赛' }页签`, {
            //     产品名称: "优驾保UBI网络物责险",
            //     运营渠道: getUrlParams().orderSource
            //         ? getUrlParams().orderSource
            //         : "",
            // });      
        },
        isShowMyBehavior(){
            if(this.isShowMyBehavior){
                // myTrack(`车旺争霸赛-活动页-我的评分`, {
                //     产品名称: "优驾保UBI网络物责险",
                //     运营渠道: getUrlParams().orderSource
                //         ? getUrlParams().orderSource
                //         : "",
                // });   
            }
        }
    },
    mounted() {
        // myTrack("车旺争霸赛-活动页", {
        //     产品名称: "优驾保UBI网络物责险",
        //     运营渠道: getUrlParams().orderSource
        //         ? getUrlParams().orderSource
        //         : "",
        // });
        // 强制禁止用户修改微信客户端的字体大小 start
        (function () {
            if (
                typeof WeixinJSBridge == "object" &&
                typeof WeixinJSBridge.invoke == "function"
            ) {
                handleFontSize();
            } else {
                if (document.addEventListener) {
                    document.addEventListener(
                        "WeixinJSBridgeReady",
                        handleFontSize,
                        false
                    );
                } else if (document.attachEvent) {
                    document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                    document.attachEvent(
                        "onWeixinJSBridgeReady",
                        handleFontSize
                    );
                }
            }

            function handleFontSize() {
                // 设置网页字体为默认大小
                WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
                // 重写设置网页字体大小的事件
                WeixinJSBridge.on("menu:setfont", function () {
                    WeixinJSBridge.invoke("setFontSizeCallback", {
                        fontSize: 0,
                    });
                });
            }
        })();
        // 强制禁止用户修改微信客户端的字体大小 end
        if (navigator.userAgent.indexOf("daka") > -1) {
            this.mobile = getUserInfo().mobile;
            this.userId = getUserInfo().userId;
        } else if (getSessionObj("dakaUser")) {
            this.mobile = getSessionObj("dakaUser").mobile || "";
            this.userId = getSessionObj("dakaUser").userId || "";
        }
        // 微信分享出去之后有openid，但是跳转投保页后由于是后台返回的地址没有了Openid,所以得提前存一下
        if (this.$route.query.openId) {
            setSessionObj("openId", this.$route.query.openId);
        }
        this.getUserOrder();
        this.getMyBehavior();
        this.getRankingData();
        this.setShare();
        // 获取分享者的userid
        getUrlParams().sharerUserId ? setSessionObj("sharerUserId", getUrlParams().sharerUserId) : null;
    },
    methods: {
        getUserOrder() {
            if (!this.mobile) {
                this.isLogin = false;
            } else {
                this.$http
                    .post(isUserOrderUrl, { mobile: this.mobile })
                    .then((res) => {
                        if (res.data.flag && res.data.data !== null) {
                            this.isLogin = res.data.data.length > 0;
                        }
                    });
            }
        },
        getMyBehavior() {
            this.$http
                .post(getMyBehaviorUrl, { mobile: this.mobile })
                .then((res) => {
                    if (res.data.flag && res.data.data !== null) {
                        this.myBehaviorData = res.data.data;
                        this.tbSubpolicyTrackInfo =
                            res.data.data.tbSubpolicyTrackInfo || {};
                        this.beatNums = res.data.data.scoreRanking;
                    }
                });
        },
        getRankingData() {
            this.$http.post(getRankingDataUrl).then((res) => {
                if (res.data.flag && res.data.data !== null) {
                    this.jumpUrl = res.data.data.returnUrl;
                }
            });
        },
        // 入参为小时
        timeChange(value) {
            let val = value * 60 * 60;
            let theTime = parseInt(val); // 需要转换的时间秒
            let theTime1 = 0; // 分
            let theTime2 = 0; // 小时
            let theTime3 = 0; // 天
            if (theTime > 60) {
                theTime1 = parseInt(theTime / 60);
                theTime = parseInt(theTime % 60);
                if (theTime1 > 60) {
                    theTime2 = parseInt(theTime1 / 60);
                    theTime1 = parseInt(theTime1 % 60);
                    if (theTime2 > 24) {
                        // 大于24小时
                        theTime3 = parseInt(theTime2 / 24);
                        theTime2 = parseInt(theTime2 % 24);
                    }
                }
            }
            let result = "";
            if (theTime > 0) {
                result = "" + parseInt(theTime) + "秒";
            }
            if (theTime1 > 0) {
                result = "" + parseInt(theTime1) + "分" + result;
            }
            if (theTime2 > 0) {
                result = "" + parseInt(theTime2) + "小时" + result;
            }
            if (theTime3 > 0) {
                result = "" + parseInt(theTime3) + "天" + result;
            }
            return result;
        },
        jump() {
            // myTrack(`车旺争霸赛-活动页-点击马上参与`, {
            //     产品名称: "优驾保UBI网络物责险",
            //     运营渠道: getUrlParams().orderSource
            //         ? getUrlParams().orderSource
            //         : "",
            // },()=>{
                window.location.href = this.jumpUrl;
            // });  
        },
        shareBtn() {
            // myTrack(`车旺争霸赛-活动页-点击立即分享`, {
            //     产品名称: "优驾保UBI网络物责险",
            //     运营渠道: getUrlParams().orderSource
            //         ? getUrlParams().orderSource
            //         : "",
            // },()=>{
                if (!this.isOut) {
                    var pageUrl = `${window.location.origin}${window.location.pathname}${window.location.search.indexOf('?')>-1?window.location.search+'&':window.location.search+'?'}orderSource=activityShare${window.location.hash}`
                    var scheme = window.btoa(unescape(encodeURIComponent(`{"code":"998","args":{"pageUrl":"${pageUrl}","eventName":"优驾保"}}`)))
                    var dakaAppUrl = `https://appapis.95155.com/h5-mobile-api/collection/2019down.html?p=${scheme}`
                    window.location.href = dakaAppUrl;
                    return;
                }
                try {
                    if (isAndroid()) {
                        window.daka.exec("share", []);
                    } else {
                        window.location.href = "native://?ios=share";
                    }
                } catch (e) {}
            // });  
        },
        setShare() {
            var pageUrl = `${window.location.origin}${window.location.pathname}${window.location.search.indexOf('?')>-1?window.location.search+'&':window.location.search+'?'}orderSource=activityShare${window.location.hash}`
            let shareurl;
            if(!getUrlParams().sharerUserId && this.userId){
                pageUrl = `${window.location.origin}${window.location.pathname}${window.location.search.indexOf('?')>-1?window.location.search+'&':window.location.search+'?'}orderSource=activityShare&sharerUserId=${this.userId}${window.location.hash}`
            }
            if (location.host.indexOf("insapp.hsbxjj.com") > -1) {
                shareurl = pageUrl;
            } else {
                shareurl =
                    "https://insapp.hsbxjj.com/weixinBridge/weixinBridge.html?redirect_uri=" +
                    encodeURIComponent(pageUrl);
            }
            let outuurl =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx19e9bec291539dce&redirect_uri=" +
                encodeURIComponent(shareurl) +
                "&response_type=code&scope=snsapi_userinfo&connect_redirect=1#wechat_redirect";
            if (isAndroid()) {
                window.share = {
                    //站外
                    title: "优驾保-货运险",
                    desc: "争当“最佳司机”，得现金奖励",
                    url: outuurl, //shareurl,
                    icon: "https://bxcx-public.oss-cn-beijing.aliyuncs.com/20250319132638/1742361997.jpg",
                    //站内
                    inStationTitle: "优驾保-货运险",
                    inStationDesc: "争当“最佳司机”，得现金奖励",
                    inStationIcon:
                        "https://bxcx-public.oss-cn-beijing.aliyuncs.com/20250319132638/1742361997.jpg",
                    inStationUrl: shareurl,
                    // wechatTimelineUseTitle: "1", 控制朋友圈显示标题还是详情
                    activeType: "bxcx2020jzz", //不确定有啥用 保留
                    tag: "保险模版",
                    category: JSON.stringify(["0", "1", "3"]),
                };
            } else {
                window.share = {
                    //站外
                    title: "优驾保-货运险",
                    desc: "争当“最佳司机”，得现金奖励",
                    url: outuurl, //shareurl,
                    icon: "https://bxcx-public.oss-cn-beijing.aliyuncs.com/20250319132638/1742361997.jpg",
                    //站内
                    inStationTitle: "优驾保-货运险",
                    inStationDesc: "争当“最佳司机”，得现金奖励",
                    inStationIcon:
                        "https://bxcx-public.oss-cn-beijing.aliyuncs.com/20250319132638/1742361997.jpg",
                    inStationUrl: shareurl,
                    // wechatTimelineUseTitle: "1", 控制朋友圈显示标题还是详情
                    activeType: "bxcx2020jzz", //不确定有啥用 保留
                    tag: "保险模版",
                    category: JSON.stringify(["0", "1", "2", "3"]),
                };
            }
        },
        checkList() {
            // 分享榜单超过 2022-07-03 24点才可以进入
            if(this.tabIndex==1 && new Date("2022","06","03").getTime() + 86399999 > new Date().getTime()){
                showMsg("榜单将在7月4日公布，快去分享活动吧~");
                return;
            }
            // myTrack(`车旺争霸赛-活动页-点击${this.tabIndex ? '分享车王' : '驾驶车王' }榜单`, {
            //     产品名称: "优驾保UBI网络物责险",
            //     运营渠道: getUrlParams().orderSource
            //         ? getUrlParams().orderSource
            //         : "",
            // });   
            this.$router.push({
                path: "/listPage",
                query: { tabIndex: this.tabIndex },
            });
        },
    },
};
</script>

<style scoped lang="scss">
@function toVw($px) {
    @return $px / 7.5 * 1vw;
}

.activePageBlue {
    background: linear-gradient(0deg, #d3e0fd 0%, #e7eeff 100%);
}

.activePageRed {
    background: #ffd4d4;
}
.activePage {
    width: toVw(750);
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: toVw(180);
    font-family: ”Microsoft YaHei”, Arial, Helvetica, sans-serif, ”宋体”;

    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;

    .header {
        width: toVw(750);
        background: url("../../assets/active/head.png") top no-repeat;
        background-size: contain;
        padding-top: toVw(580);
        .topTitle {
            text-align: center;
            font-size: toVw(40);
            font-weight: bold;
            margin-bottom: toVw(29);
            color: #ff1818;
        }
        .topTitle > span:first-child {
            color: #2c6af6;
        }
        .switchTab {
            width: 90%;
            height: toVw(103);
            margin: 0 auto;
            position: relative;
            display: flex;
            align-items: center;
            margin-bottom: toVw(30);
            > div {
                position: absolute;
            }
        }
        .tabBtnBlue {
            > div:nth-child(1) {
                background: url("../../assets/active/drive1.png") 100%/100%;
                width: toVw(396);
                height: toVw(103);
                left: 0;
            }
            > div:nth-child(2) {
                background: url("../../assets/active/share1.png") 100%/100%;
                width: toVw(308);
                height: toVw(70);
                right: 0;
            }
        }
        .tabBtnRed {
            > div:nth-child(1) {
                background: url("../../assets/active/drive2.png") 100%/100%;
                width: toVw(308);
                height: toVw(70);
                left: 0;
            }
            > div:nth-child(2) {
                background: url("../../assets/active/share2.png") 100%/100%;
                width: toVw(396);
                height: toVw(103);
                right: 0;
            }
        }
        .descRed {
            .productDesc {
                .title {
                    color: #ff1616;
                    > span:nth-child(1) {
                        background: url("../../assets/active/triangle2.png")
                            100%/100%;
                    }
                    > span:nth-child(2) {
                        background: url("../../assets/active/triangle2.png")
                            100%/100%;
                    }
                }
                .points {
                    > span:after {
                        background: #ff1717;
                    }
                }
            }
        }
        .productDesc {
            width: toVw(680);
            background: #ffffff;
            box-shadow: 0 toVw(6) toVw(21) 0 rgba(34, 105, 240, 0.17);
            border-radius: toVw(16);
            margin: 0 auto;
            box-sizing: border-box;
            padding: 0 toVw(50) toVw(30) toVw(42);
            text-align: left;
            margin-bottom: toVw(29);

            .title {
                height: toVw(127);
                line-height: toVw(127);
                font-size: toVw(36);
                font-weight: bold;
                color: #3b74f8;
                text-shadow: 0 5px 5px rgba(59, 70, 210, 0.3);
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                width: 80%;
                margin: 0 auto;
                > span {
                    width: toVw(72);
                    height: toVw(19);
                }
                > span:nth-child(1) {
                    background: url("../../assets/active/triangle.png") 100%/100%;
                }
                > span:nth-child(2) {
                    background: url("../../assets/active/triangle.png") 100%/100%;
                    transform: rotateZ(180deg);
                }
            }

            .desc {
                font-size: toVw(28);
                font-weight: 500;
                color: #0c245d;
                line-height: toVw(48);
                margin-bottom: toVw(29);
            }

            .points {
                font-size: toVw(26);
                font-weight: 500;
                color: #0c245d;
                line-height: toVw(48);
                position: relative;
                > span:after {
                    content: "";
                    background: #3b74f8;
                    border-radius: 6px;
                    position: absolute;
                    width: toVw(106);
                    height: toVw(12);
                    bottom: toVw(12);
                    left: 0;
                    opacity: 0.5;
                }
            }

            .list {
                font-size: toVw(26);
                color: #2a3d67;
                line-height: toVw(40);
            }

            .mb20 {
                margin-bottom: toVw(20);
            }

            .mb30 {
                margin-bottom: toVw(30);
            }
        }
    }

    .tipsBox {
        margin-top: toVw(50);
        > img {
            width: toVw(119);
            margin: toVw(70) auto toVw(26);
            display: block;
        }
        .tipText {
            font-size: toVw(34);
            font-weight: 500;
            color: #3b74f8;
            margin-bottom: toVw(30);
            line-height: toVw(50);
            text-align: center;
            > span {
                font-size: toVw(64);
                font-weight: 800;
                color: #3b74f8;
            }
        }

        .lSpacing4 {
            letter-spacing: toVw(4);
        }

        .mb18 {
            margin-bottom: toVw(18);
        }

        .tips {
            width: toVw(566);
            display: flex;
            justify-content: flex-start;
            text-align: left;
            margin: 0 auto toVw(40);

            > img {
                width: toVw(30);
                height: toVw(30);
                margin-right: toVw(5);
                margin-top: toVw(4);
            }

            > span {
                font-size: toVw(28);
                color: #3b74f8;
                line-height: toVw(40);
            }
        }
    }

    .myBehavior {
        width: toVw(171);
        height: toVw(70);
        opacity: 0.7;
        border-radius: toVw(35) 0 0 toVw(35);
        background: #006cff;
        position: fixed;
        right: 0;
        bottom: toVw(140);
        display: flex;
        align-items: center;
        > span {
            font-size: toVw(28);
            color: #ffffff;
        }

        > img {
            width: toVw(35);
            height: toVw(35);
            margin-right: toVw(5);
            margin-left: toVw(15);
        }
    }

    .bottomBtn {
        position: fixed;
        bottom: 0;
        height: toVw(110);
        line-height: toVw(110);
        text-align: center;
        width: 100%;
        background: #ffffff;
        font-size: toVw(35);
        > div {
            display: inline-block;
        }
        > div:nth-child(1) {
            width: 35.3%;
        }
        > div:nth-child(2) {
            width: 64.7%;
            color: #ffffff;
            font-weight: bold;
            // background: linear-gradient(269deg, #476DF8, #3F7AFF);
        }
    }
    .mask-div {
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
    }
    .myBehaviorBox {
        background: #ffffff;
        position: fixed;
        text-align: left;
        width: toVw(620);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: toVw(16);
        padding: 0 toVw(30);
        .close {
            position: absolute;
            top: toVw(38);
            right: toVw(35);
            width: toVw(32);
            height: toVw(32);
            z-index: 4;
        }
        .close-bottom {
            position: absolute;
            bottom: toVw(-180);
            left: 50%;
            transform: translateX(-50%);
            width: toVw(80);
            height: toVw(80);
        }
        .behavior-title {
            width: toVw(279);
            height: toVw(70);
            line-height: toVw(70);
            font-size: toVw(35);
            letter-spacing: 3px;
            font-weight: bold;
            background: url("../../assets/active/title-img.png") 100%/100%;
            position: absolute;
            top: toVw(-24);
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            color: #ffffff;
        }
        .behavior-content{
            max-height: toVw(1000);
            overflow: scroll;
        }
        .beatNums {
            height: toVw(152);
            line-height: toVw(152);
            font-size: toVw(36);
            font-weight: 800;
            color: #3b74f8;
            text-align: center;
            margin-top:toVw(30);

            > span {
                font-size: toVw(64);
                font-weight: 800;
                color: #FF4002;
                line-height: 1;
                vertical-align: text-bottom;
            }
        }
        .behaviorList {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: toVw(30);
            color: #333333;
            margin-bottom: toVw(28);

            .key {
                width: toVw(160);
            }

            .save {
                padding: 0 toVw(18);
                height: toVw(38);
                background-color: #ff7304;
                border-radius: toVw(19) toVw(19) toVw(19) 0;
                font-size: toVw(26);
                line-height: toVw(44);
                font-weight: bold;
                color: #ffffff;
                text-align: center;
                margin-left: toVw(6);
            }
        }
        .title {
            line-height: 1;
            font-size: toVw(32);
            font-weight: bold;
            color: #333333;
            position: relative;
            margin: toVw(50) 0 toVw(35) 0;

            &::after {
                content: "";
                position: absolute;
                bottom: toVw(-6);
                left: 0;
                width: toVw(202);
                height: toVw(8);
                background: linear-gradient(
                    0deg,
                    #1a5be6 1%,
                    #2f6fff 56.99999999999999%,
                    #4f9bfd 100%
                );
                opacity: 0.2;
                border-radius: toVw(4);
            }
        }
        .stateList {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: toVw(40);

            .circle {
                display: inline-block;
                width: toVw(36);
                height: toVw(36);
                line-height: toVw(40);
                font-size: toVw(28);
                font-weight: bold;
                background: linear-gradient(
                    0deg,
                    #1a5be6 1%,
                    #2f6fff 56.99999999999999%,
                    #4f9bfd 100%
                );
                border-radius: 50%;
                margin-right: toVw(16);
                color: #ffffff;
                text-align: center;
            }

            .style {
                font-size: toVw(30);
                color: #333333;
            }

            .result {
                min-width: toVw(134);
                box-sizing: border-box;
                background: #2e6cf7;
                border: 1px solid #2e6cf7;
                border-radius: toVw(24);
                padding: toVw(10) toVw(26);
                line-height: 1;
                font-size: toVw(28);
                color: #ffffff;
                text-align: center;
            }
        }
        .improveBox {
            .list {
                // padding: toVw(34) toVw(62) toVw(82) toVw(50);

                .topTitle {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: toVw(28);
                    font-size: toVw(30);
                    color: #333333;

                    .circle {
                        display: inline-block;
                        width: toVw(36);
                        height: toVw(36);
                        line-height: toVw(40);
                        font-size: toVw(28);
                        font-weight: bold;
                        background: linear-gradient(
                            0deg,
                            #1a5be6 1%,
                            #2f6fff 56.99999999999999%,
                            #4f9bfd 100%
                        );
                        border-radius: 50%;
                        margin-right: toVw(16);
                        color: #ffffff;
                        text-align: center;
                    }
                }

                .content {
                    font-size: toVw(28);
                    color: #666666;
                    margin-left: toVw(52);
                    line-height: toVw(42);
                    margin-bottom: toVw(42);

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

    .blueStyleBtn {
        > div:nth-child(1) {
            color: #466ff9;
        }
        > div:nth-child(2) {
            background: linear-gradient(269deg, #476df8, #3f7aff);
        }
    }
    .redStyleBtn {
        > div:nth-child(1) {
            color: #ff1616;
        }
        > div:nth-child(2) {
            background: #ff2222;
        }
    }
}
</style>